import {
  BookingAdapter,
  type BookingAdapterProps,
} from '../adapters/booking-api-client/booking.ts'

import { defineBackendStore } from './backend-store.ts'

export interface BookingModule {
  retrieveBooking: (token: string) => Promise<BookingAdapterProps>
  deleteBooking: (token: string) => Promise<BookingAdapterProps>
}

export const useBookingServiceStore = defineBackendStore<BookingModule>(
  'booking-service',
  {
    actions: {
      async deleteBooking(token: string): Promise<BookingAdapterProps> {
        const bookingPayload = await this.apiClient.bookingService.delete({
          token,
        })
        const bookingAdapter = new BookingAdapter(bookingPayload)
        try {
          return bookingAdapter.toHotelBooking()
        } catch (error) {
          throw new Error(`'Error while converting booking payload: ${error}`)
        }
      },
      async retrieveBooking(token: string): Promise<BookingAdapterProps> {
        const bookingPayload =
          await this.apiClient.bookingService.retrievePublic({
            token,
          })
        const bookingAdapter = new BookingAdapter(bookingPayload)
        try {
          return bookingAdapter.toHotelBooking()
        } catch (error) {
          throw new Error(`'Error while converting booking payload: ${error}`)
        }
      },
    },
  },
)
